import { render, staticRenderFns } from "./target-template.vue?vue&type=template&id=229d954a&"
import script from "./target-template.vue?vue&type=script&lang=js&"
export * from "./target-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports